import { NavLink } from 'react-router-dom';
import { Home, Users, UsersRound, User, UserCheck } from 'lucide-react';
import { useLang } from '@/contexts/LangContext';
import { useNavBadges } from '@/contexts/NavBadgesContext';

const items = [
  { to: '/app',      icon: Home,       key: 'home',    tid: 'nav-home',    badgeKey: null },
  { to: '/feed',     icon: Users,      key: 'feed',    tid: 'nav-feed',    badgeKey: 'feed' },
  { to: '/friends',  icon: UserCheck,  key: 'friends', tid: 'nav-friends', badgeKey: 'friends' },
  { to: '/groups',   icon: UsersRound, key: 'groups',  tid: 'nav-groups',  badgeKey: 'groups' },
  { to: '/profile',  icon: User,       key: 'profile', tid: 'nav-profile', badgeKey: null },
];

export default function BottomNav() {
  const { t } = useLang();
  const { badges } = useNavBadges();
  return (
    <nav className="gm-bottomnav" data-testid="bottom-nav">
      {items.map(({ to, icon: Icon, key, tid, badgeKey }) => {
        const showDot = badgeKey && badges[badgeKey];
        return (
          <NavLink
            key={to}
            to={to}
            end={to === '/app'}
            data-testid={tid}
            className={({ isActive }) => `gm-bottomnav-item ${isActive ? 'is-active' : ''}`}
          >
            <span className="relative inline-flex">
              <Icon size={22} strokeWidth={2.5} />
              {showDot && (
                <span
                  className="absolute -top-0.5 -right-1.5 w-2.5 h-2.5 rounded-full bg-[#58CC02] ring-2 ring-white"
                  data-testid={`${tid}-badge-dot`}
                  aria-label={`new ${key}`}
                />
              )}
            </span>
            <span className="gm-bottomnav-label">{t(key)}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
